import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';

export const spacerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
});

export const spacerPaddingCss = css({
  padding: '64px 0',
  [MediaQueries.md]: {
    padding: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    padding: '160px 0',
  },
});

export const cardColumnCss = css({
  display: 'flex',
  [MediaQueries.lg]: {
    flexWrap: 'wrap',
    maxWidth: 380,
    minWidth: 347,
    width: 'auto',
  },
});

export const solutionCardsGridCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  "[data-item='solution-card'], [data-item='misc-card']": {
    marginBottom: 40,
  },
});
